import { Map } from 'immutable';

import { isEbayInvalidMarketplace } from '../shops';
import { shapeId } from '../listings/listings';
import { getSize } from '../iterable/getSize';

import { CHANNEL_BY_ID, CHANNEL_ID, EBAY } from '../../constants/channels';
import { LISTING } from '../../constants/listings';
import { EMPTY } from '../../constants';

export function shapeLinkedProductForAPI({ product, userShops }) {
  if (getSize(product) === 0 || getSize(userShops) === 0) return product;

  const shopId = product.get('shopId');
  const db = userShops.getIn(['byId', shopId, 'db']);
  const channel = userShops.getIn(['byId', shopId, 'channel']);
  const productId = product.get('productId');
  const channelProductId = product.get('channelProductId');

  return {
    channel_id: CHANNEL_ID[channel],
    channel_product_id: channelProductId,
    db,
    product_id: parseInt(productId),
    shop_id: parseInt(shopId),
  };
}

export function shapeLinkedProductForApp({ products, userShops }) {
  function reduceProducts(result, product) {
    const channel = CHANNEL_BY_ID[product.channel_id];
    const channelProductId = shapeId(product[LISTING[channel].CHANNEL_PRODUCT_ID]);
    const shopId = shapeId(product.shop_id);
    const productId = shapeId(product.id);

    if (!userShops.hasIn(['byId', shopId])) return result;

    switch (channel) {
      case EBAY: {
        if (isEbayInvalidMarketplace(userShops.getIn(['byId', shopId, 'syncStatus']))) {
          return result;
        }

        break;
      }

      default: {
        break;
      }
    }

    return result.push(
      Map({
        channelProductId,
        productId,
        shopId,
      })
    );
  }

  return products.reduce(reduceProducts, EMPTY.LIST);
}
